import produce, { Draft } from 'immer';
import { SET_SELECTED_YEAR, YearActionTypes } from '../actions/yearActions';

export interface YearState {
  selectedYear: number;
}

const currentYear = new Date().getFullYear();

const initialState: YearState = {
  selectedYear: currentYear, // Año actual por defecto
};

const yearReducer = (state = initialState, action: YearActionTypes): YearState => {
  switch (action.type) {
    case SET_SELECTED_YEAR: {
      return produce(state, (draft: Draft<YearState>) => {
        draft.selectedYear = action.payload.year;
      });
    }

    default: {
      return state;
    }
  }
};

export default yearReducer;
